import { Injectable, Injector } from '@angular/core';
import { ModalService } from './modal.service';
import { LevelSelectionType } from './types/level-selection-type';
import { ChangeLevelModalComponent } from '../home/level-selection/change-level-modal/change-level-modal.component';
import { MODAL_DATA } from './tokens/modal-data.token';

@Injectable({
  providedIn: 'root',
})
export class LevelSelectionService {
  constructor(
    private readonly modalService: ModalService
  ) {}

  public openChangeLevelModal() {
    this.modalService.open(ChangeLevelModalComponent,{
      windowClass: 'change-level-modal',
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'modal-backdrop-static',
      injector: Injector.create({
        providers: [
          { provide: MODAL_DATA, useValue: { levelSelectionType: LevelSelectionType.MANUAL_CHANGE } }
        ]
      })
    })
  }
}


// WEBPACK FOOTER //
// ./ts/app/shared/level-selection.service.ts